(function () {
    function updateYotpoUgcAccessibility() {
        var items = document.querySelectorAll('.yotpo-pictures-widget .yotpo-single-image-container');

        items.forEach(function (item, index) {
            var img = item.querySelector('img.yotpo-image');
            var trigger = item.querySelector('.y-image-wrapper[role="button"]');

            if (!img) return;

            var originalAlt = (img.getAttribute('alt') || '').trim();
            if (!originalAlt) return;

            originalAlt = originalAlt
                .replace(/^Shopper photo of\s+/i, '')
                .replace(/^Shopper photo\s+\d+\s+of\s+/i, '')
                .trim();

            var position = index + 1;
            var descriptiveAlt = 'Shopper photo ' + position + ' of ' + originalAlt;

            img.setAttribute('alt', descriptiveAlt);

            if (trigger) {
                trigger.setAttribute('aria-label', 'Open ' + descriptiveAlt);
            }
        });
    }

    function observeYotpoWidget() {
        var widget = document.querySelector('.yotpo-pictures-widget');
        if (!widget) return;

        updateYotpoUgcAccessibility();

        var observer = new MutationObserver(function () {
            updateYotpoUgcAccessibility();
        });

        observer.observe(widget, {
            childList: true,
            subtree: true
        });
    }

    document.addEventListener('DOMContentLoaded', observeYotpoWidget);
    window.addEventListener('load', observeYotpoWidget);
})();